import { render, staticRenderFns } from "./PopupRiskInfoEp2.vue?vue&type=template&id=03c360ed&scoped=true"
import script from "./PopupRiskInfoEp2.vue?vue&type=script&lang=js"
export * from "./PopupRiskInfoEp2.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskInfoEp2.vue?vue&type=style&index=0&id=03c360ed&prod&lang=scss&scoped=true"
import style1 from "./PopupRiskInfoEp2.vue?vue&type=style&index=1&id=03c360ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c360ed",
  null
  
)

export default component.exports